import './App.css';
import './shared/fonts/stylesheet.css';
import './shared/ui/CleanUI/CleanUI.css';

import { Route, Routes, useNavigate, useRoutes } from 'react-router-dom';
import { ReCaptchaProvider } from './shared/providers/ReCaptchaProvider';
import { routes_config, uninitialization_routes } from './shared/routes/index.jsx';
import { useStore } from './shared/stores/context.js';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { axiosInstance } from './shared/api/axiosInstance.js';
import { observer } from 'mobx-react-lite';
import { checkOnExpiredToken } from './shared/utils/checkOnExpiredToken.js';

window.global = window;

function App() {
  const { userStore } = useStore();
  const route_elements = useRoutes(userStore.routes);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const sid = Cookies.get('sid');
        const refreshToken = Cookies.get('refreshToken');

        if (!refreshToken) {
          navigate('/login');
          return;
        }
        const isExpiredToken = checkOnExpiredToken();
        console.log('check', isExpiredToken);
        if (isExpiredToken) {
          const response = await userStore.updateRefreshToken();
          await userStore.getData();
        } else {
          if (sid) {
            axiosInstance.defaults.headers = {
              Sessid: sid,
            };
            userStore.getData();
          } else {
            navigate('/login');
          }
        }
      } catch (e) {}
    };
    checkAuthorization();
  }, []);

  return route_elements;
}

export default observer(App);
